import {
  Datagrid,
  DateField,
  Filter,
  List,
  ResourceComponentProps,
  ShowButton,
  TextField,
  TextInput,
} from 'react-admin';

import { FC } from 'react';

export const ChatsFilter: FC<ResourceComponentProps> = (props) => (
  <Filter {...props}>
    <TextInput label="По id пользователя" source="chatMembers.customerId||$eq" alwaysOn />
    <TextInput label="По id диалога" source="id||$eq" alwaysOn />
    <TextInput label="По id объявления" source="offerId||$eq" alwaysOn />
  </Filter>
);

const ChatsList = (props: ResourceComponentProps) => {
  return (
    <List filters={<ChatsFilter />} {...props}>
      <Datagrid>
        <TextField label="Объявление" source="title" />
        <TextField sortable={false} label="Пользователь 1" source="chatMembers.[0].customer.fullName" />
        <TextField sortable={false} label="Пользователь 2" source="chatMembers.[1].customer.fullName" />
        <DateField locales="rus" label="Создано" source="createdAt" />
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export default ChatsList;
